import { useEffect, useState } from 'react';
import Button from '@/components/Button.jsx';
import FloatingMenu from '@/components/v3/FloatingMenu.jsx';

const PageTableFloatingMenu = ({ rowClass, parentRef = null, actions = [] }) => {
  const [selectedCount, setSelectedCount] = useState(0);

  const updateSelectedCount = () => {
    const selectedElements = document.querySelectorAll(`${rowClass}.selected`);
    setSelectedCount(selectedElements.length);
  };

  useEffect(() => {
    const observer = new MutationObserver((mutationsList) => {
      for (const mutation of mutationsList) {
        if (mutation.type === 'attributes' || mutation.type === 'childList') {
          updateSelectedCount();
        }
      }
    });

    if (parentRef.current) {
      observer?.observe(parentRef.current, { attributes: true, childList: true, subtree: true });
    }

    return () => {
      observer?.disconnect();
    };
  }, [parentRef?.current]);

  const SelectedCount = ({ count }) => {
    return (
      <div className={'selected-count'}>
        <div className={'selected-count-text'}>{count}</div>
        <span className={'selected-count-label'}>Selected</span>
      </div>
    );
  };

  return (
    <FloatingMenu className={'comp-page-table-floating-menu'} show={selectedCount > 0} leftContent={<SelectedCount count={selectedCount} />}>
      {actions.map((action, idx) => (
        <Button key={idx} className={action.className} size={action.size || 'sm'} icon={action.icon} onClick={action.onClick}>
          {selectedCount > 0 ? `${action.label}${selectedCount > 1 ? 's' : ''}` : action.label}
        </Button>
      ))}
    </FloatingMenu>
  );
};

export default PageTableFloatingMenu;
